import ContactForm from "../ContactForm/ContactForm";
import "./ContentRight.scss";

const ContentRight = (props: any) => {
  return (
    <div className="first-section-content-right">
      <div className="form-area">
        <ContactForm />
      </div>
    </div>
  );
};

ContentRight.propTypes = {};

export default ContentRight;
